export default __webpack_public_path__ + "assets/fonts/eeef0d00ba381cf1628c6b2a517592cc.otf";